import { TFunction } from 'i18next';
import { CancellationReason } from '@/entities/consignments';

export const getCancelationReasons = (t: TFunction): { value: CancellationReason; label: string }[] => [
  { value: 'A', label: t('requestHistory.cancellationReason.A') },
  { value: 'L', label: t('requestHistory.cancellationReason.L') },
  { value: 'S', label: t('requestHistory.cancellationReason.S') },
  { value: 'E', label: t('requestHistory.cancellationReason.E') },
  { value: 'O', label: t('requestHistory.cancellationReason.O') }
];

export const getPriorityOptions = (t: TFunction): { value: string; label: string }[] => [
  { value: 'urgent', label: t('dispatchPriorityName.2') },
  { value: 'high', label: t('dispatchPriorityName.3') },
  { value: 'normal', label: t('dispatchPriorityName.4') },
  { value: 'low', label: t('dispatchPriorityName.5') }
];
